import { Link } from '@99designs/emu';
import { linkTo } from '@99designs/routing';
import { IconFreelancer, IconMoneyBack, IconStar, IconSupport, IconTailored } from './icons';
import type { ZendeskLanguage } from '@99designs/routing';
import type { Reason } from './ReasonCard';

export const getReasons = (language: ZendeskLanguage = 'en'): ReadonlyArray<Readonly<Reason>> => [
    {
        heading: __('Verified freelance designers'),
        description: __(
            'Our designers are vetted, creative professionals with verified industry experience.'
        ),
        icon: <IconFreelancer />,
    },
    {
        heading: __('Tailored design options'),
        description: __(
            "Logos, websites, packaging design and more. No matter your design needs, we'll help you find a creative expert."
        ),
        icon: <IconTailored />,
    },
    {
        heading: __('24/7 design support'),
        description: __(
            'Get help when you need it from our support team of design experts. No question is too small or complex!'
        ),
        icon: <IconSupport />,
    },
    {
        heading: __('Money-back guarantee on contests'),
        description: (
            <>
                {__(
                    'Great design, guaranteed. Love your designs or get your money back on all contests.'
                )}
                &nbsp;
                <Link
                    target="__blank"
                    href={`${linkTo.supportUrl('204108729', 'articles', language)}`}
                >
                    {__('T&Cs apply')}
                </Link>
            </>
        ),
        icon: <IconMoneyBack />,
    },
];

export const getReasonsContestFocused = (
    language: ZendeskLanguage = 'en'
): ReadonlyArray<Readonly<Reason>> => [
    {
        heading: __placeholder('4.8/5 star rating'),
        description: (
            <>
                {__placeholder('That’s our average rating from')}
                &nbsp;
                <Link target="_blank" href={'/testimonials'}>
                    37,533 customer reviews.
                </Link>
                &nbsp;
                {__placeholder('Happy designers make happy clients.')}
            </>
        ),
        icon: <IconStar />,
    },
    {
        heading: __placeholder('100% money-back guarantee'),
        description: (
            <>
                {__placeholder(
                    'Great design, guaranteed. Love your final design or get your money back.'
                )}
                &nbsp;
                <Link
                    target="__blank"
                    href={`${linkTo.supportUrl('204108729', 'articles', language)}`}
                >
                    {__('T&Cs apply')}
                </Link>
            </>
        ),
        icon: <IconMoneyBack />,
    },
    {
        heading: __placeholder('Verified freelance logo designers'),
        description: __placeholder(
            'Our logo designers are vetted, creative professionals with verified industry experience who take the time to understand your business.'
        ),
        icon: <IconFreelancer />,
    },
    {
        heading: __placeholder('24/7 design support'),
        description: (
            <>
                {__placeholder(
                    'Get help when you need it with our support team of real bonafide humans. No question is too small or complex!'
                )}
            </>
        ),
        icon: <IconSupport />,
    },
];
